import React from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BannerSlider() {
    var settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 767,
              settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      };
  return (
    <div>
        <div className="slider p-relative">
            <Slider {...settings} className="main-banner arrow-layout-1 ">
                <div className="slide-item"> <img src="/tm/react/bycycle/assets/images/slider-1.jpg" className="image-fit" alt="Slider"/>
                <div className="transform-center">
                    <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                        <div className="slider-content">
                            <h1 className="text-custom-white">Enjoy Tha <span className="text-custom-blue"> Bicycle </span> Ride </h1>
                            <ul className="custom">
                            <li className="text-custom-white"> <i className="fas fa-dollar-sign"></i> Best Price Guaranteed </li>
                            <li className="text-custom-white"> <i className="fas fa-car"></i> Home Pickups </li>
                            <li className="text-custom-white"> <i className="fas fa-laptop"></i> Easy Bookings </li>
                            <li className="text-custom-white"> <i className="fas fa-headphones-alt"></i> 24/7 Customer Care </li>
                            </ul>
                            <Link to="/bicycle" className="btn-first btn-small">Find Out More</Link> </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="slide-item"> <img src="/tm/react/bycycle/assets/images/slider-2.jpg" className="image-fit" alt="Slider"/>
                <div className="transform-center">
                    <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                        <div className="slider-content">
                            <h1 className="text-custom-white">Enjoy Tha <span className="text-custom-blue"> Bicycle </span> Ride </h1>
                            <ul className="custom">
                            <li className="text-custom-white"> <i className="fas fa-dollar-sign"></i> Best Price Guaranteed </li>
                            <li className="text-custom-white"> <i className="fas fa-car"></i> Home Pickups </li>
                            <li className="text-custom-white"> <i className="fas fa-laptop"></i> Easy Bookings </li>
                            <li className="text-custom-white"> <i className="fas fa-headphones-alt"></i> 24/7 Customer Care </li>
                            </ul>
                            <Link to="/bicycle" className="btn-first btn-small">Find Out More</Link> </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="slide-item"> <img src="/tm/react/bycycle/assets/images/slider-1.jpg" className="image-fit" alt="Slider"/>
                <div className="transform-center">
                    <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                        <div className="slider-content">
                            <h1 className="text-custom-white">Book your <span className="text-custom-blue">Bicycle </span> through your app!</h1>
                            <p className="text-custom-white">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text.</p>
                            <Link to="/bicycle" className="btn-first btn-small">Find Out More</Link> </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </Slider>
        </div>
    </div>
  )
}

export default BannerSlider